module.exports = __webpack_public_path__ + "static/media/iot-application-01.75bde941.jpg";